var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSnail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000121260545634110112480000007950350636096941755_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 449 505.9",
    style: {
      enableBackground: "new 0 0 449 505.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#745B4E;}\r\n\t.st1{fill:#7F6438;}\r\n\t.st2{fill:#12100E;}\r\n\t.st3{fill:#AD877A;}\r\n\t.st4{fill:#3B3B3B;}\r\n\t.st5{fill:#FFC7B4;}\r\n\t.st6{fill:#998675;}\r\n\t.st7{fill:#FFF4FA;}\r\n\t.st8{fill:#3F60FF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.1,234.1C-49.8,385.3,107,439.5,220.6,435.4s286.8-92.8,207-216.3c-50.7-78.4-96.3-126.9-209.9-122.8 C104,100.4,53.5,148.3,16.1,234.1L16.1,234.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.9,253.3C-49.4,392,107.1,441.2,220.7,437.1c113.6-4.2,287.1-85.9,207.6-198.8 c-50.5-71.7-95.9-116-209.5-111.8S54.5,174.6,16.9,253.3L16.9,253.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47.8,359.6c-59.9,95.6,69.9,134.1,165.2,134.1s243.3-52.9,180.2-134.1c-40.1-51.6-76.8-83.9-172.2-83.9 S81.8,305.3,47.8,359.6L47.8,359.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M39.6,371.2c-62.5,95.6,72.9,134.1,172.5,134.1s254-52.9,188.1-134.1c-41.9-51.6-80.2-83.9-179.8-83.9 S75.1,317,39.6,371.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M217.3,432.4c16.8,0.5,30.4,2.9,30.3,5.5s-13.8,4.4-30.6,3.9s-23.2-2.7-23.1-5.3S200.5,431.9,217.3,432.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M283.1,335.9h11c6.6,0,12-5.4,12-12l-0.7-135.7c-0.1-24.4,3.3-48.6,9.2-72.3c9.3-37.2-24.9-41.3-20.4-51h-11 c-6.6,0-12,5.4-12,12v247C271.1,330.5,276.5,335.9,283.1,335.9L283.1,335.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M249.9,28.2c-9.5,30.5,13.2,64.7,50.6,76.3s75.4-3.8,84.9-34.3s-17-51.6-54.4-63.2 C293.5-4.6,259.4-2.3,249.9,28.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M262.7,36.2c-7.7,24.8,10.7,52.5,41.1,61.9c30.4,9.4,61.2-3.1,68.9-27.8s-13.8-41.9-44.2-51.3 S270.4,11.4,262.7,36.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M296.3,58.7c-1.2,3.8,1.9,8.1,6.8,9.6s9.9-0.3,11-4.1s-2.3-6.5-7.3-8S297.5,54.9,296.3,58.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M158.8,330.2h-13c-7.8,0-14.2-3.9-14.2-8.8l0.9-99.1c0.2-17.8-3.9-35.5-10.9-52.8 c-11-27.2,29.5-30.2,24.2-37.2h13c7.8,0,14.2,3.9,14.2,8.8v180.3C173,326.3,166.6,330.2,158.8,330.2L158.8,330.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M46.5,107.3c0,32,31.8,57.9,70.9,57.9s70.9-25.9,70.9-57.9S156.8,63,117.6,63S46.5,75.3,46.5,107.3L46.5,107.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M60.8,110.6c0,25.9,25.8,47,57.6,47s57.6-21,57.6-47s-25.6-35.9-57.4-35.9S60.8,84.6,60.8,110.6L60.8,110.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M101.8,128.5c0,4.1,4.4,7.4,9.9,7.4s9.9-3.3,9.9-7.4s-4.4-5.7-9.9-5.7S101.8,124.4,101.8,128.5L101.8,128.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M263.1,33.9c-4,10,22.5,15.9,52.9,25.3c30.4,9.4,53.1,21.6,57.1,8.7c4-12.9-2-39-44.2-49.8 C298.1,10.3,272.6,10.2,263.1,33.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M61.6,103.4c-1.5,10.7,25.6,10.1,57.4,12.1c31.7,2,56.7,8.5,57.6-5c0.9-13.4-11.1-37.4-54.7-38 C90.1,72.3,65.3,78.2,61.6,103.4L61.6,103.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnail);
export default __webpack_public_path__ + "static/media/SNAIL.96529d30a2d5c741f1c7ec1772963594.svg";
export { ForwardRef as ReactComponent };